export const gameDefaults = {
    startVideo: '/video/intro.mp4',
    endVideo: '/video/final.mp4',
    checkpoints: [
        {
            id: 'capilla_calle_sol',
            name: 'Capilla Calle El Sol',
            clue: 'Busca la “casa” de la cruz del Sol.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Capilla_Sol.mp3',
                    title: 'Capilla del Sol',
                    content: [
                        { text: 'La calle El Sol, antiguamente conocida como de La Lagaña, era otro de los caseríos que conformaban el antiguo núcleo urbano del Realejo de Arriba. En ella residían personas de múltiples oficios y condición, en sencillas viviendas al margen de las grandes extensiones de terreno de haciendas y fincas limítrofes, como “El Cercado”, “Piloto” o “El Llano”.' },
                        { text: 'Hacia 1864, gracias a la generosidad de sus vecinos, se construye una capilla  para colocar el Santo Madero, que desde tiempo atrás recibía culto en la calle. Dos años después obtienen licencia para poder celebrar misa en la recién construida capilla.' },
                        { image: '/images/hitos/capilla_sol.jpg' },
                        { text: 'En su altar interior preside el Santo Madero cubierto de plata, ricamente ornamentado con creativos enrames de flores durante todo el año, siendo su fiesta principal la Invención de la Cruz el tres de mayo.' },
                    ]
                },
                gallery: {
                    isCompleted: false,
                    title: 'Galleria',
                    gallery: [
                        { image: '/images/hitos/ermita_sol/galeria/1998.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/1999.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2000.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2001.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2002.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2003.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2004.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2005.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2006.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2007.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2008.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2009.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2010.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2011.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2012.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2013.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2014.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2015.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2016.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2017.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2018.jpg' },
                        { image: '/images/hitos/ermita_sol/galeria/2019.jpg' },
                    ],
                },
                image360: {
                    isCompleted: false,
                    title: 'La ermita',
                    image: '/images/hitos/ermita_sol/360.jpg',
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.58409471084255,
                lat: 28.378506729318424,
            },
        },
        {
            id: 'capilla_calle_medio',
            name: 'Capilla calle del Medio',
            clue: 'Visita la capilla con un altar escalonado.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Capilla_Medio.mp3',
                    title: 'Capilla Del Medio',
                    content: [
                        { text: 'El establecimiento poblacional junto a la iglesia del Apóstol Santiago y el camino que subía a la cumbre, fue el origen de esta calle que recibe su nombre por encontrarse en una lomada en medio de dos barrancos. En su recorrido nos encontramos con sobresaliente arquitectura de los siglos XVIII y XIX, levantada gracias al asentamiento de destacadas familias de la localidad.' },
                        { image: '/images/hitos/capilla_medio.jpg' },
                        { text: 'Desde finales del siglo XVI se conoce la existencia de una Cruz en un lugar muy cercano al actual, junto al camino que sube a La Romera. No será hasta finales del siglo XIX cuando se construya una capilla para cobijar el Santo Madero, anterior a la que hoy conocemos edificada en 1991.' },
                        { text: 'En su interior la Santa Cruz, pintada de verde y blanco, preside un altar escalonado preparado para recibir artísticas ornamentaciones florales durante su festividad del tres de mayo.' },
                    ]
                },
                gallery: {
                    isCompleted: false,
                    title: 'Galleria',
                    gallery: [
                        { image: '/images/hitos/ermita_el_medio/galeria/1987.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1988.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1989.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1990.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1991.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1992.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1993.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1994.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1995.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1996.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1997.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1998.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/1999.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2000.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2001.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2002.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2003.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2004.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2005.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2006.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2007.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2008.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2009.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2010.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2011.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2012.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2013.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2014.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2015.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2016.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2017.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2018.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2019.jpg' },
                        { image: '/images/hitos/ermita_el_medio/galeria/2020.jpg' },
                    ],
                },
                image360: {
                    isCompleted: false,
                    title: 'Capilla Del Medio',
                    image: '/images/hitos/ermita_el_medio/360.jpg'
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.585452555170495,
                lat: 28.377306219677706,
            },
        },
        {
            id: 'iglesia',
            name: 'Parroquia Matriz del Apóstol Santiago',
            clue: 'Una visita al interior del templo puede ser buena idea.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/Iglesia.mp3',
                    title: 'Parroquia de Santiago Apóstol',
                    content: [
                        { text: 'Los inicios de este templo se vinculan con el fin de la conquista de las islas en 1496. Una primitiva ermita daría paso, décadas después, a un templo de mayores proporciones, con tres naves, capillas colaterales y sacristías en su cabecera. Sus portadas de cantería son de las primeras fases constructivas del templo, siendo la más antigua la del costado norte, fechada en 1521. Asimismo destaca la techumbre de la capilla mayor, con decoración mudéjar. La torre rematada por un puntiagudo chapitel se construye en 1774.' },
                        { image: '/images/hitos/iglesia.jpg' },
                        { text: 'En su interior encontramos importantes muestras del arte canario de los siglos XVII y XVIII como retablos, esculturas y pinturas. Fue declarada Monumento Nacional en 1983.' },
                    ]
                },
                image360: {
                    isCompleted: false,
                    title: 'Iglesia Santiago Apostol',
                    image: '/images/hitos/iglesia_santiago_apostol/360.jpg'
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.58518142653462,
                lat: 28.38086090742305,
            },
        },
        {
            id: 'iglesia cruz santa',
            name: 'Iglesia Parroquial de la Santa Cruz',
            clue: 'Una visita al interior del templo puede ser buena idea.',
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/nada.mp3',
                    title: 'Parroquia de la Santa Cruz',
                    content: [
                        { text: 'Una leyenda local cuenta el hallazgo milagroso de un Madero por un jinete en el cauce del barranco conocido como de La Raya. En un lugar cercano se construye una primitiva ermita para acoger la Santa Cruz, conocida como la Vera Cruz de Higa. No será hasta mediados del siglo XVIII cuando se traslade este recinto a un sitio más céntrico del naciente núcleo poblacional.' },
                        { image: '/images/hitos/infoparroquia.jpg' },
                        { text: 'La Cruz original es la titular del templo parroquial dentro de un estuche de niquel realizado a principios del siglo XX.' },
                    ]
                }
            },
            marker: createInfoMarker(),
            position: {
                lon: -16.5660923,
                lat: 28.3782395,
            },
        },
        {
            id: 'genio_4',
            name: 'Genio',
            clue: 'Busca a una misteriosa figura flotante.',
            lookAtPlayer: true,
            description: '',
            isCompleted: false,
            accesibility: {
                visibleOn: [],
                accesibleOn: [],
            },
            activities: {
                info: {
                    isCompleted: false,
                    audio: '/sound/El_Genio.mp3',
                    title: 'El Genio de Los Realejos',
                    content: [
                        { text: 'Cuenta la leyenda que el Genio existe antes de que Los Realejos tuviera ese nombre, es un ser mágico y misterioso que aparece cuando menos lo esperas en el municipio.' },
                        { text: 'El Genio de Los Realejos fue un personaje creado por José Cívico y Porto, administrador de la Hacienda de Los Príncipes, para una obra teatral titulada la Loa a la Cruz con destino a las fiestas de la Santa Cruz que se celebraban en la ermita de San Sebastián en 1869.' },
                        { image: '/images/hitos/Genio.jpg' },
                        { text: 'Este personaje como se describe en el libreto era un venerable anciano vestido con pieles, con un bastón y con corona de ramas. Tenía el conocimiento de toda la historia del lugar desde el origen de los tiempos hasta el presente.' },
                    ]
                },
                chat: {
                    isCompleted: false,
                    title: 'El Genio',
                    src: '/chats/genio_cruz_santa.json',
                    events: [
                        {
                            onNodeAdded: ['adios'],
                            success: true
                        }
                    ]
                },
            },
            marker: {
                image: '/images/game/genio.png',
                width: 50,
                height: 50 * (209 / 125),
            },
            position: {
                lon: -16.56648,
                lat: 28.37823,
            },
        },
    ]
};
function isNearOf(targetId) {
    return {
        targets: [targetId],
        distance: 20,
    };
}
function isCompleted(...targets) {
    return {
        targets,
        isCompleted: true
    };
}
function isUncompleted(...targets) {
    return {
        targets,
        isCompleted: false
    };
}
function fullMatch(...strings) {
    return strings.map(s => [`^${s}$`, 'i']);
}
function createInfoMarker() {
    const width = 30;
    return {
        image: '/game_images/characters/info.svg',
        width: width,
        height: width * (130.748 / 81.134),
    };
}
